import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=3aea080e&"
import script from "./profile.ts?vue&type=script&lang=ts&"
export * from "./profile.ts?vue&type=script&lang=ts&"
import style0 from "./profile.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports